import type { TiptapState } from '@/types';

export const findFirstImageSrc = (node: TiptapState | undefined): string | undefined => {
  if (!node || typeof node !== 'object') {
    return undefined;
  }

  if (node.type === 'imageBlock' && typeof node.attrs?.src === 'string' && node.attrs.src) {
    return node.attrs.src;
  }

  if (!Array.isArray(node.content)) {
    return undefined;
  }

  for (const child of node.content) {
    const found = findFirstImageSrc(child);
    if (found) {
      return found;
    }
  }

  return undefined;
};
